import { __awaiter } from "tslib";
import { OtelNetworkAttrs } from '../types';
import { trace, } from '@opentelemetry/api';
import { isPatternMatch } from '../utils/regex';
import { CompositePropagator, W3CBaggagePropagator, W3CTraceContextPropagator, } from '@opentelemetry/core';
import { B3InjectEncoding, B3Propagator } from '@opentelemetry/propagator-b3';
import { AWSXRayPropagator } from '@opentelemetry/propagator-aws-xray';
export function handlePropagators(config, tracerProvider) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        if ((_a = config.traceParentInHeader) === null || _a === void 0 ? void 0 : _a.enabled) {
            let propagators = [];
            const { propagateB3TraceHeader, propagateAwsXrayTraceHeader } = ((_b = config.traceParentInHeader) === null || _b === void 0 ? void 0 : _b.options) || {};
            if (!propagateAwsXrayTraceHeader && !propagateB3TraceHeader) {
                propagators = [
                    ...propagators,
                    new W3CBaggagePropagator(),
                    new W3CTraceContextPropagator(),
                ];
            }
            if (propagateAwsXrayTraceHeader) {
                propagators.push(new AWSXRayPropagator());
            }
            if (propagateB3TraceHeader) {
                const { singleHeader, multiHeader } = propagateB3TraceHeader;
                if (singleHeader) {
                    propagators.push(new B3Propagator());
                }
                if (multiHeader) {
                    propagators.push(new B3Propagator({ injectEncoding: B3InjectEncoding.MULTI_HEADER }));
                }
            }
            tracerProvider.register({
                propagator: new CxPropagator(config, new CompositePropagator({
                    propagators,
                })),
            });
        }
    });
}
class CxPropagator {
    constructor(config, internalPropagator) {
        this.config = config;
        this.internalPropagator = internalPropagator;
    }
    extract(context, carrier, getter) {
        return this.internalPropagator.extract(context, carrier, getter);
    }
    fields() {
        return this.internalPropagator.fields();
    }
    inject(context, carrier, setter) {
        var _a, _b;
        const allowedUrls = (_b = (_a = this.config.traceParentInHeader) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.allowedTracingUrls;
        if (allowedUrls) {
            const span = trace.getSpan(context);
            const url = span.attributes[OtelNetworkAttrs.URL];
            let isUrlAllowed = isPatternMatch(url, allowedUrls, 'allowedTracingUrls');
            if (isUrlAllowed) {
                this.internalPropagator.inject(context, carrier, setter);
            }
            return;
        }
        this.internalPropagator.inject(context, carrier, setter);
    }
}
